import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {
  username = '';
  password = '';
  error: string | null = null;
  notice: string | null = null;
  loading = false;

  private returnUrl = '/';

  constructor(
    private readonly auth: AuthService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    const params = this.route.snapshot.queryParamMap;
    this.returnUrl = params.get('returnUrl') ?? '/';
    this.username = params.get('email') ?? '';
    if (params.get('reset') === 'success') {
      this.notice = 'Your password has been reset. Sign in with your new password.';
    }
  }

  async onSubmit(): Promise<void> {
    this.error = null;
    this.notice = null;
    this.loading = true;
    try {
      const outcome = await this.auth.signIn(this.username, this.password);
      switch (outcome) {
        case 'DONE':
          await this.router.navigateByUrl(this.returnUrl);
          break;
        case 'RESET_PASSWORD':
          // An admin reset this account; Cognito has already emailed a code.
          await this.router.navigate(['/reset-password'], {
            queryParams: { email: this.username, reason: 'admin' },
          });
          break;
        case 'CONFIRM_SIGN_UP':
          await this.router.navigate(['/confirm-signup'], { queryParams: { email: this.username } });
          break;
      }
    } catch (err: unknown) {
      this.error = err instanceof Error ? err.message : 'Sign-in failed. Please try again.';
    } finally {
      this.loading = false;
    }
  }
}
